export default "__VITE_ASSET__Cz25KNXR__"